import { render, staticRenderFns } from "./senderDetail.vue?vue&type=template&id=7991a858&scoped=true&"
import script from "./senderDetail.vue?vue&type=script&lang=js&"
export * from "./senderDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7991a858",
  null
  
)

export default component.exports